module.exports = __webpack_public_path__ + "static/media/logo-internal.2fbb6b15.png";